export default "__VITE_ASSET__QEFTmB1___"